import React, { useEffect, useState } from "react";
import useHttp from "../../../../hook/use-http"; import { Chart } from 'react-google-charts';
import NoData from '../../Driveanalysis/NoData';
import ChartLoader from '../../Driveanalysis/ChartLoader';
import BuketsTableVehicle from '../BuketsTableVehicle';
import { API_URL_MAIN } from '../../../../constants/driveglobalfilterinitalstates';
// import { GoogleChartWrapper, ReactGoogleChartEvent } from "react-google-charts";
import * as $ from 'jquery';
import WaterMark from "../../DashboardMain/WaterMark";
import { BsZoomIn } from "react-icons/bs";
import { type } from "@testing-library/user-event/dist/type";
import { Bar, getElementAtEvent } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
  scales
} from "chart.js";
ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);
let Maxchartdata
let res_result

function SocPerChargeVehicle({ apiend, gloablfilter, type }) {
  const [chartdata, setChartData] = useState([]);
  const [apiresponce, SetApiResponce] = useState([]);
  const [filteredData, SetfilteredData] = useState([]);
  const { isLoading, error, sendReq: fetchData } = useHttp();
  const [check, SetCheck] = useState("slow")
  const [chartname, SetChartName] = useState("SOC per charge - Slow chrg");
  let barcolor
  let modal_title = "";
  let toPush = [];
  const appyData = (data) => {
    res_result = data;
    toPush = [];

    let responce = {
      "<10": 0,
      "20": 0,
      "30": 0,
      "40": 0,
      "50": 0,
      "60": 0,
      "70": 0,
      "80": 0,
      "90": 0,
      "<=100": 0,
    };
    if (res_result.length === 0) {
      setChartData((prestate) => []);
    }
    if (res_result.length !== 0) {
      SetApiResponce(res_result);

      let d = res_result[0];
      let id = 0

      if (d.SOC_1.value)
        responce["<10"] = d.SOC_1.value;
      if (d.SOC_2.value)
        responce["20"] = d.SOC_2.value;
      if (d.SOC_3.value)
        responce["30"] = d.SOC_3.value;
      if (d.SOC_4.value)
        responce["40"] = d.SOC_4.value
      if (d.SOC_5.value)
        responce["50"] = d.SOC_5.value;
      if (d.SOC_6.value)
        responce["60"] = d.SOC_6.value;
      if (d.SOC_7.value)
        responce["70"] = d.SOC_7.value;
      if (d.SOC_8.value)
        responce["80"] = d.SOC_8.value
      if (d.SOC_9.value)
        responce["90"] = d.SOC_9.value;
      if (d.SOC_10.value)
        responce["<=100"] = d.SOC_10.value;

      toPush.push(d.SOC_1.value)
      toPush.push(d.SOC_2.value)
      toPush.push(d.SOC_3.value)
      toPush.push(d.SOC_4.value)
      toPush.push(d.SOC_5.value)
      toPush.push(d.SOC_6.value)
      toPush.push(d.SOC_7.value)
      toPush.push(d.SOC_8.value)
      toPush.push(d.SOC_9.value)
      toPush.push(d.SOC_10.value)
      SetfilteredData(toPush)

      let res_result_final = [["Element", "Count", { role: "style" }]]
      let loop_keys = Object.keys(responce);
      loop_keys = ["<10", "20", "30", "40", "50", "60", "70", "80", "90", "<=100"]
      let countcheck = 0
      for (const key in responce) {
        if (responce[key] > 0) {
          countcheck = countcheck + 1
        }
      }
      loop_keys.map(x => {
        if (countcheck)
          // res_result_final.push([x, responce[x], barcolor]);
          res_result_final.push([x, responce[x], `{stroke-width: 1;stroke-color: black;color:${barcolor}}`]);
      })
      const labels = ["<10", "20", "30", "40", "50", "60", "70", "80", "90", "<=100"]

      Maxchartdata = {
        labels,
        datasets: [
          {
            label: "Max Battery temp (oC)",
            data: responce,
            backgroundColor: barcolor,
            borderWidth: 1,
            borderColor: "black",
          },
        ]
      };

      setChartData((prestate) => res_result_final);
    } else {
      setChartData((prestate) => []);
    }
  }

  let hAxis = {};

  if (apiend == "rangebarchart") {
    modal_title = "Real World Range Distribution";
    hAxis = {
      gridlines: {
        color: 'transparent'
      },
      title: 'Range (Km)',
      minValue: 0,
      format: 'short',
      direction: 1,
      slantedText: true,
      slantedTextAngle: 90
    };
  }

  if (apiend == "energybarchart") {
    modal_title = "Net Energy consumption";
    hAxis = {
      gridlines: {
        color: 'transparent'
      },
      title: 'Wh / Km',
      minValue: 0,
      format: 'short',
      direction: 1,
      slantedText: true,
      slantedTextAngle: 90
    };
  }

  const options1 = {
    responsive: true,
    categoryPercentage: 1.0,
    barPercentage: 1.0,
    scales: {
      x: {
        grid: {
          color: 'white',
        },
        title: {
          display: true,
          text: 'SOC Per Charge (%)'
        },
        suggestedMin: 0,
      },

      y: {
        grid: {
          color: 'white',
        },
        title: {
          display: true,
          text: 'Charging Cycles'
        },
        suggestedMin: 0,
      },
    },

    plugins: {
      legend: {
        display: false
      },
    }
  }

  const options = {
    hAxis: {
      gridlines: {
        color: 'transparent'
      },
      title: 'SOC Per Charge (%)',
      minValue: 0,
      format: 'short',
      direction: 1,
      slantedText: true,
      slantedTextAngle: 90
    },

    vAxis: {
      gridlines: {
        color: 'transparent'
      },
      title: 'Charging Cycles',
      minValue: 0,
      format: 'short',
    },
    bar: { groupWidth: "100%" }
    , legend: "none",
  };

  useEffect(() => {
    if (type === "Slow") {
      fetchData({ url: API_URL_MAIN + "chargingpage/" + apiend, body: { filterdata: gloablfilter } }, appyData)
      SetChartName("SOC per charge - Slow chrg")
      SetCheck("slow")
      barcolor = "#348393"
    } else {
      SetCheck("fast")
      fetchData({ url: API_URL_MAIN + "chargingpage/" + "socpervehiclefast", body: { filterdata: gloablfilter } }, appyData)
      SetChartName("SOC per charge - Fast chrg")
      barcolor = "#FFA650"
    }
  }, [gloablfilter, type])

  const appyDataClick = (data) => {
    let hits = data;

    hits.map((i, key) => {
      toPush.push(i.fields.delta_soc[0])
    })
    SetfilteredData(toPush.sort())
  }
  return (
    <>
      <div className="modal fade" id={apiend + "_modal"} tabIndex={-1} aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div className="modal-dialog modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLabel">{chartname}</h5>
              <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" />
            </div>
            <div className="modal-body d-flex justify-content-center" style={{ height: '400px' }}>
              {
                (isLoading) ? <ChartLoader /> : ((chartdata.length > 1) ? <Bar options={options1} data={Maxchartdata} width="100%" height="65px" />
                  : <NoData />
                )}
            </div>
          </div>
        </div>
      </div>
      <strong className="Zoom_first_page d-flex justify-content-end" style={{ cursor: "pointer" }} data-bs-toggle="modal" data-bs-target={"#" + apiend + "_modal"} > <BsZoomIn /> </strong>
      <WaterMark />
      {(isLoading) ? <ChartLoader /> : ((chartdata.length > 1) ? <Chart chartType="ColumnChart" width="100%" height="230px" data={chartdata} options={options} chartEvents={[
        {
          eventName: "select",
          callback({ chartWrapper }) {
            const chart = chartWrapper.getChart()
            const selection = chart.getSelection()
            const [selectedItem] = selection;
            const { row } = selectedItem;
            const barvalue = (chartWrapper.getDataTable().Wf[row].c[0].v);
            let from_bucket;
            let to_bucket;
            const count = chartWrapper.getDataTable().Wf[row].c[1].v;

            if (count !== 0) {
              if (barvalue === "<10") {
                from_bucket = 1
                to_bucket = 10
              } else if (barvalue === "<=100") {
                from_bucket = 90
                to_bucket = 100
              } else {
                from_bucket = barvalue - 10
                to_bucket = barvalue
              }
              if (check === "slow")
                fetchData({ url: API_URL_MAIN + "chargingpage/socper_vehicle_click", body: { filterdata: gloablfilter, type: "Slow", from_bucket: parseInt(from_bucket), to_bucket: parseInt(to_bucket) } }, appyDataClick)
              else
                fetchData({ url: API_URL_MAIN + "chargingpage/socper_vehicle_click_fast", body: { filterdata: gloablfilter, type: "Slow", from_bucket: parseInt(from_bucket), to_bucket: parseInt(to_bucket) } }, appyDataClick)

              window.$('#exampleModal__' + apiend).modal('show');
            }
          }
        }
      ]}
      /> : <NoData />)}


      <div className="modal fade" id={"exampleModal__" + apiend} tabIndex={-1} aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLabel">{chartname}</h5>
              <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" />
            </div>
            <div className="modal-body" style={{ overflowY: 'scroll', height: '250px' }}>
              <table className="table table-striped">
                <thead style={{ backgroundColor: '#32879c', color: '#fff' }}>
                  <tr>
                    <th scope="col">value</th>
                  </tr></thead>
                <tbody>
                  <BuketsTableVehicle data={filteredData} />
                </tbody></table>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default SocPerChargeVehicle;